import { Component, Input } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { featherArrowLeft } from '@ng-icons/feather-icons';

@Component({
  selector: 'app-nav-button',
  imports: [NgIcon, RouterModule],
  templateUrl: './nav-button.component.html',
  viewProviders: [provideIcons({ featherArrowLeft })]
})
export class NavButtonComponent {
  @Input() route: string | string[] = '/';
}
